export default class PaymentService {
  constructor(axiosIns, serviceConfig) {
    this.axiosIns = axiosIns;
    this.serviceConfig = serviceConfig;
  }

  createPaymentIntent(payload) {
    return this.axiosIns.post(this.serviceConfig.payment, payload);
  }

  getPaymentIntentList(args) {
    return this.axiosIns.get(`${this.serviceConfig.payment}`, { params: args });
  }

  deletePaymentIntent(id) {
    return this.axiosIns.delete(`${this.serviceConfig.payment}/${id}`);
  }

  payWithCreditCard({ paymentIntentId, ...args }) {
    return this.axiosIns.post(`${this.serviceConfig.payment}/${paymentIntentId}/process`, args);
  }
}
